<div class="mtest-medical-test-item-results">
  <a routerLink="/medical-test/{{requestId}}/detail"
     [attr.aria-label]="'SI_DETAIL_MEDICAL_TEST' | translate">
    <div class="pasi-grey-box p-3 pointer pasi-hover_scale" [class.pasi-grey-box_blue]="areResultsAvailable">
      <div class="d-flex align-items-center mb-1">
        <div class="pasi-title_main d-flex align-items-center">
          <i class="pasi-states-caption-states entity-{{statesCaptionEntities.REQUEST_TYPE}} state_{{requestTypeId}} mr-1"></i>
          <span>{{title || benefitTypeName}}</span>
        </div>
      </div>
      <div class="row pasi-subtitle_regular mtest-medical-test-item-results_info">
        <div *ngIf="useCaseDate" class="col-12">
          <div class="d-flex align-items-center">
            <i class="icosun-appointment_confirmed mtest-medical-test-item-results_icon"></i>
            <span class="ml-2 text-truncate">
              {{(useCaseDateText | translate: {date: (useCaseDate | amDateFormat: 'L LT')})}}
            </span>
          </div>
        </div>
        <div *ngIf="centerName" class="col-12">
          <div class="d-flex align-items-center">
            <i class="icosun-map mtest-medical-test-item-results_icon"></i>
            <span class="ml-2 text-truncate">{{centerName}}</span>
          </div>
        </div>
        <div class="col-12 d-flex flex-wrap align-items-start">
          <div class="d-flex align-items-center mtest-medical-test-item-results_info_results mr-2"
               [class.mtest-medical-test-item-results_info_results-available]="areResultsAvailable">
            <i class="icosun-infocircle mtest-medical-test-item-results_icon"></i>
            <span class="ml-2">{{(areResultsAvailable ? 'SI_RESULTS_AVAILABLE' : 'SI_RESULTS_NOT_AVAILABLE') | translate}}</span>
          </div>
          <div class="ml-auto">
            <si-mtest-medical-test-download-icons [requestId]="requestId"
                                                  [openTop]="openTop"
                                                  [images]="images"
                                                  [actions]="actions"
            ></si-mtest-medical-test-download-icons>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
